module.exports = function (mod, card1, card2) {
  var stage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'midwar';
  var card1img = '';
  var card2img = '';
  try {
    card1img = mod.returnCardImage(card1);
  } catch (err) {}
  try {
    card2img = mod.returnCardImage(card2);
  } catch (err) {}
  var st = 'Mid-War';
  if (stage == 'latewar') {
    st = 'Late-War';
  }
  var html = "<div class=\"headline-overlay\">\n\t    <div class=\"title\">Choose Your ".concat(st, " Card</div>\n\t    <div class=\"cards\">\n\t      <div class=\"card option\" id=\"").concat(card1, "\">").concat(card1img, "</div>\n\t      <div class=\"card option\" id=\"").concat(card2, "\">").concat(card2img, "</div>\n\t    </div>\n\t    <div class=\"help\">* card will be randomly shuffled into deck</div>\n        ");
  return html;
};